<!-- attach-to-matter.component.html -->
<div class="overlay">
    <div class="dialog">
      <div class="dialog-header">
        <h2 class="modal-title">Attach To Matter</h2>
        <button class="close-button" (click)="onCancel()">X</button>
      </div>
      
      <div class="dialog-content">
        <h3>Select Matter(s)</h3>
        
        <div class="search-container">
          <input 
            type="text" 
            [formControl]="searchControl" 
            placeholder="Search here..." 
            class="search-input"
          />
          <span class="search-icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <circle cx="11" cy="11" r="8"></circle>
              <path d="M21 21l-4.35-4.35"></path>
            </svg>
          </span>
        </div>
        
        <!-- <div class="matters-list">
          <div 
            *ngFor="let matter of filteredMatters" 
            class="matter-item"  [class.disabled]="matter.disabled"
            (click)="!matter.disabled && toggleMatterSelection(matter)"
          >
            <div class="checkbox">
              <input 
                type="radio" 
                [checked]="matter.selected"
                [disabled]="matter.disabled" 
                (change)="toggleMatterSelection(matter, $event)"
                (click)="$event.stopPropagation()"
              />
            </div>
            <span class="matter-name">{{ matter.name }}</span>
          </div>
        </div> -->

        <div class="matters-list">
          <div *ngFor="let matter of filteredMatters" class="matter-item" [class.disabled]="matter.disabled"
            (click)="!matter.disabled && selectMatter(matter)">
            <div class="checkbox">
              <input type="radio" name="matter-selection" [checked]="matter.selected" [disabled]="matter.disabled"
                (change)="selectMatter(matter, $event)"
                (click)="$event.stopPropagation()" />
            </div>
            <span class="matter-name">{{ matter.name }}</span>
          </div>
        </div>

      </div>
      
      <div class="dialog-footer">
        <button class="btn-cancel" (click)="onCancel()">Cancel</button>
        <button 
          class="btn-save" 
          [disabled]="!hasSelectedMatters" 
          [ngClass]="{'btn-save-disabled': !hasSelectedMatters}"
          (click)="onSave()"
        >Save</button>
      </div>
    </div>
  </div>
